export default "__VITE_ASSET__4fc8e2ef__"